<template>
  <v-dialog
    width="880"
    :value="dialogs.npsQuiz"
    :transition="false"
    :scrollable="false"
    content-class="nps-dialog-wrapper"
    persistent
  >
    <v-card class="quiz-card-wrapper">
      <!-- КНОПКА ЗАКРЫТЬ -->
      <div
        class="quiz-close-button"
        @click="closeDialog"
      >
        <v-icon
          :size="18"
          color="gray"
        >
          mdi-close
        </v-icon>
      </div>

      <div class="quiz-wrapper">
        <img class="quiz-logo" :src="dolphinLogo" alt="dolphin logo" />
        <iframe
          :src="`https://s.chkmkt.com/?e=312692&d=i&h=84CEBD679FC3E60&l=${npsQuizLanguage}`"
          class="quiz-iframe"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import dolphinLogo from "@/assets/logo-purple.svg";

export default {
  name: 'DialogNpsQuiz',

  data () {
    return {
      dolphinLogo
    }
  },

  computed: {
    ...mapGetters({
      dialogs: 'main/dialogs'
    }),

    npsQuizLanguage () {
      // Show english version when locale is chinese
      return this.$i18n.locale === 'ru' ? 'ru' : 'en'
    }
  },

  methods: {
    closeDialog () {
      localStorage.setItem('npsQuizShowed', new Date())

      this.$store.dispatch('main/closeDialog', 'npsQuiz')
    }
  }
}
</script>

<style>
.nps-dialog-wrapper {
  border-radius: 8px;
}

.quiz-close-button {
  position: absolute;
  top: 25px;
  right: 25px;
  cursor: pointer;
}

.quiz-logo {
  margin-bottom: 24px;
}

.quiz-wrapper {
  padding: 40px 40px 16px 40px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.quiz-iframe {
  width: 100%;
  height: 413px;
  border: unset;
}
</style>
